if (!customElements.get('product-includes')) {
  class ProductIncludes extends HTMLElement {
    static ITEM_ACTIVE_CLASS = 'is-active';
    static LINK_ACTIVE_CLASS = 'border-dashed-circle';

    constructor() {
      super();

      this.activeIndex = 0;

      this.isDragging = false;
      this.startX = 0;
      this.scrollStart = 0;

      this.onMove = this.onMove.bind(this);
      this.onUp = this.onUp.bind(this);
      this.onDown = this.onDown.bind(this);
    }

    activateIndex(index) {
      this.links[this.activeIndex].classList.remove(
        ProductIncludes.LINK_ACTIVE_CLASS,
      );
      this.items[this.activeIndex].classList.remove(
        ProductIncludes.ITEM_ACTIVE_CLASS,
      );

      this.activeIndex = index;

      this.links[this.activeIndex].classList.add(
        ProductIncludes.LINK_ACTIVE_CLASS,
      );
      this.items[this.activeIndex].classList.add(
        ProductIncludes.ITEM_ACTIVE_CLASS,
      );

      const link = this.links[this.activeIndex];
      const parent = link.parentElement;

      parent.scrollTo({
        left: link.offsetLeft - parent.offsetWidth / 2 + link.offsetWidth / 2,
        behavior: 'smooth',
      });
    }

    handleClick(event) {
      const target = event.target.closest('[js-includes-link]');
      if (!target) return;

      event.preventDefault();

      this.activateIndex(Number(target.getAttribute('js-includes-link')));
    }

    initInterval() {
      if (!this.intervalDuration) return;
      if (this.interval) clearInterval(this.interval);

      this.interval = setInterval(() => {
        let newIndex = this.activeIndex + 1;
        if (newIndex >= this.links.length) newIndex = 0;

        this.activateIndex(newIndex);
      }, this.intervalDuration);
    }

    handleMouseEnter() {
      clearInterval(this.interval);
    }

    handleMouseLeave() {
      this.initInterval();
    }

    onMove(e) {
      if (!this.isDragging) return;
      const dx = e.clientX - this.startX;
      this.draggableElement.scrollLeft = this.scrollStart - dx;
    }

    onUp() {
      this.isDragging = false;
      this.draggableElement.style.cursor = 'grab';
      this.draggableElement.removeEventListener('mousemove', this.onMove);
      this.draggableElement.removeEventListener('mouseup', this.onUp);
    }

    onDown(e) {
      this.isDragging = true;
      this.startX = e.clientX;
      this.scrollStart = this.draggableElement.scrollLeft;
      this.draggableElement.style.cursor = 'grabbing';
      this.draggableElement.addEventListener('mousemove', this.onMove);
      this.draggableElement.addEventListener('mouseup', this.onUp);
      e.preventDefault();
    }

    initDrag() {
      this.draggableElement = this.querySelector('[js-drag]');
      if (!this.draggableElement) return;

      this.draggableElement.addEventListener('mousedown', this.onDown);
    }

    connectedCallback() {
      this.intervalDuration = Number(this.getAttribute('js-interval-duration'));
      this.links = this.querySelectorAll('[js-includes-link]');
      this.items = this.querySelectorAll('[js-includes-item]');

      if (!this.links.length || !this.items.length) return;

      this.addEventListener('click', this.handleClick.bind(this));
      this.addEventListener('mouseenter', this.handleMouseEnter.bind(this));
      this.addEventListener('mouseleave', this.handleMouseLeave.bind(this));

      this.initInterval();
      this.initDrag();
    }
  }

  customElements.define('product-includes', ProductIncludes);
}
